@if (isFetching) {
  <div class="viator-card">
    <div class="viator-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>

      <button class="viator-card__favourite btn-hurt btn-hurt--circle">
        <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
      </button>
    </div>

    <div class="viator-card__content">
      <h3 #titleRef>
        ‎
        <ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
      </h3>

      <!--        TODO: This price not send right now from BE and its not possible -->
<!--      <div class="viator-card__info">-->
<!--        <div class="viator-card__price">-->
<!--          <p class="viator-card__price&#45;&#45;night">From</p>-->
<!--          <p class="viator-card__price&#45;&#45;payment fetching" #priceRef>{{ viator?.currency === "EUR" ? "&#8364;" : "&#36;" }}-->
<!--            <ngx-skeleton-loader [theme]="{height: priceRef.clientHeight + 'px', width: '40px', margin: '0 0 0 5px'}"></ngx-skeleton-loader>-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="viator-card__footer">
      <button class="viator-card__read-more btn-default btn-blue">
        View
      </button>
    </div>
    <div class=" viator-card__logo">
      <mat-icon [svgIcon]="eSvgIcons.BOOKING"></mat-icon>
    </div>
  </div>
} @else {
  @if (viator) {
    <div class="viator-card">
      <div class="viator-card__header">
        <figure>
          <img [src]="(viator.image && viator.image[0] ? viator.image[0]?.url : viator.imageUrl) | safeUrl" alt="country-image">
        </figure>

        <div class="viator-card__favourite btn-hurt btn-hurt--circle"
             [class.active]="favoritesProviderService.isFavorite('viator', viator.id)"
             (click)="toggleHurt($event, viator)">
          <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
        </div>
      </div>
      <div class="viator-card__content">
        <h3>{{ viator.name }}</h3>

<!--        TODO: This price not send right now from BE and its not possible -->
<!--        <div class="viator-card__info">-->
<!--          <div class="viator-card__price">-->
<!--            <p class="viator-card__price&#45;&#45;night">From</p>-->
<!--            <p class="viator-card__price&#45;&#45;payment">{{ viator.currency === "EUR" ? "&#8364;" : "&#36;" }}{{ viator.price | number: '1.0-2' }}</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="viator-card__footer">
        <a class="viator-card__read-more btn-default btn-blue"
           target="_blank"
           [href]="viator.url | safeUrl"
        >
          View
        </a>
      </div>
      <div class=" viator-card__logo">
        <mat-icon [svgIcon]="eSvgIcons.VIATOR"></mat-icon>
      </div>
    </div>
  }
}
